export function getCurrentRawZoom(state) {
  return state.jigsaw.zoom;
}



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/zoom/selectors.js